import React from "react"
import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export interface UnsupportedStateModalProps {
  onHide: () => void
}

export default function UnsupportedStateModal(props: UnsupportedStateModalProps) {
  const { t } = useTranslation()

  return (<>
    <Modal show size="lg" fullscreen="sm-down" centered backdrop="static" onHide={props.onHide}>
      <Modal.Body>
        <h3>{t("registration.demographics.unsupportedState")}</h3>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>{t("registration.button.close")}</Button>
      </Modal.Footer>
    </Modal>
  </>)
}
